import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';

/** Загрузка данных виджета с обработкой ошибок и ручным обновлением */
export function useWidgetData<T>(url: string, params?: Record<string, string | undefined>) {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const paramsKey = JSON.stringify(params || {});
  const seq = useRef(0);

  const load = useCallback(async () => {
    const current = ++seq.current;
    setLoading(true);
    try {
      const clean = Object.fromEntries(Object.entries(JSON.parse(paramsKey)).filter(([, v]) => v));
      const res = await axios.get(url, { params: clean });
      if (current !== seq.current) return;
      setData(res.data);
      setError(null);
    } catch (err: any) {
      if (current !== seq.current) return;
      setError(err?.response?.data?.message || 'Не удалось загрузить данные');
    } finally {
      if (current === seq.current) setLoading(false);
    }
  }, [url, paramsKey]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, reload: load };
}

/** Дата из MSSQL приходит как «локальное время в UTC» - выводим без сдвига часового пояса */
export function formatServerDate(iso?: string | null): string {
  if (!iso) return '-';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '-';
  return d.toLocaleString('ru-RU', {
    timeZone: 'UTC', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit'
  });
}

/** Дата из MySQL (уведомления) приходит как реальный момент времени */
export function formatLocalDate(iso?: string | null): string {
  if (!iso) return '-';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '-';
  return d.toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
}
